module.exports = __webpack_public_path__ + "img/information-ticket.5e01977f.svg";